import React from 'react';
import { Link, useParams } from 'react-router-dom';
import { ArrowLeftIcon, ArrowUpRightIcon } from 'lucide-react';
import { PortfolioGrid } from '../components/PortfolioGrid';
import { Button } from '../components/Button';
import { NotFound } from './NotFound';
import { artists } from '../data/artists';
import { portfolio } from '../data/portfolio';
export function ArtistDetail() {
  const {
    slug
  } = useParams();
  const artist = artists.find(a => a.slug === slug);
  if (!artist) return <NotFound data-id="element-220" data-mp="3iq2rep4svbwh" />;
  const work = portfolio.filter(p => p.artist === artist.name);
  return <>
      <section className="mx-auto max-w-6xl px-6 pb-20 pt-32 xl:pt-44" data-id="element-221" data-mp="3dqyepoio2w1e">
        <Link to="/artists" className="inline-flex items-center gap-2 font-slab text-xs font-bold uppercase tracking-[0.2em] text-ink-muted hover:text-white" data-id="element-222" data-mp="39pwhtec82w2l">
          <ArrowLeftIcon className="h-4 w-4" aria-hidden="true" data-id="element-223" data-mp="22dw02z04ogjv" />
          All artists
        </Link>
        <div className="mt-10 grid gap-12 md:grid-cols-[minmax(0,5fr)_minmax(0,7fr)] md:items-start" data-id="element-224" data-mp="1y967pk4ohk3p">
          <img src={artist.image} alt={`Portrait of ${artist.name}`} className="aspect-[4/5] w-full object-cover" data-id="element-225" data-mp="1e8qz9dv22ev6" />
          <div data-id="element-226" data-mp="1j4y4t5jjhocl">
            <p className="font-script text-xl italic text-ink-muted" data-id="element-227" data-mp="1579lw3918ra6">{artist.roles.join(' · ')}</p>
            <h1 className="mt-2 font-slab text-4xl font-bold uppercase tracking-[0.12em] md:text-5xl" data-id="element-228" data-mp="198uu3bamghe1">{artist.name}</h1>
            <p className="mt-4 font-slab text-xs font-bold uppercase tracking-[0.2em] text-ink-faint" data-id="element-229" data-mp="vgy5vic2qrmx">Trip Ink Tattoo Company</p>

            <div className="mt-8 space-y-5 text-lg leading-relaxed text-ink-muted" data-id="element-230" data-mp="108y9plv9m4os">
              {artist.bio.length > 0 ? artist.bio.map(para => <p key={para.slice(0, 24)} data-id="element-231" data-mp="qi3p0lxo3d5g">{para}</p>) : <p data-id="element-232" data-mp="qgaj58uvowyi">
                  {artist.name} is a resident tattoo artist at Trip Ink Tattoo Company. Request an appointment to book with {artist.name.split(' ')[0]}.
                </p>}
            </div>

            {artist.quote && <blockquote className="mt-10 border-l-2 border-white pl-6" data-id="element-233" data-mp="2j7w789srh8g8">
                <p className="font-script text-xl italic leading-relaxed md:text-2xl" data-id="element-234" data-mp="2efmd0hkm5m85">“{artist.quote}”</p>
                <footer className="mt-4 font-slab text-xs font-bold uppercase tracking-[0.2em] text-ink-muted" data-id="element-235" data-mp="29g9q5wtqsf5k">— {artist.name}</footer>
              </blockquote>}

            <div className="mt-10 flex flex-wrap gap-3" data-id="element-236" data-mp="325qcqduol1tv">
              <Button to="/book-now" data-id="element-237" data-mp="3256x53si6pj0">Book with {artist.name.split(' ')[0]}</Button>
              {artist.instagram && <a href={`https://www.instagram.com/${artist.instagram}/`} target="_blank" rel="noreferrer" className="inline-flex items-center gap-2 border border-white px-8 py-4 font-slab text-xs font-bold uppercase tracking-[0.25em] transition-colors duration-150 ease-out hover:bg-white hover:text-ink" data-id="element-238" data-mp="2x4ja0t7easu2">
                  @{artist.instagram}
                  <ArrowUpRightIcon className="h-4 w-4" aria-hidden="true" data-id="element-239" data-mp="3oenpreyucb9t" />
                </a>}
            </div>

            {artist.slug === 'rick-trip' && <div className="mt-12 border-t border-ink-line pt-6" data-id="element-240" data-mp="19fz3pt40ecb">
                <h2 className="font-slab text-xs font-bold uppercase tracking-[0.2em] text-ink-muted" data-id="element-241" data-mp="184uxovr54ko">From the blog</h2>
                <Link to="/blog/meet-las-vegas-tattoo-artist-rick-trip" className="mt-3 block font-slab font-bold uppercase tracking-[0.12em] hover:underline hover:underline-offset-4" data-id="element-242" data-mp="61ze8r7g3hj8">
                  Meet Las Vegas Tattoo Artist Rick Trip
                </Link>
              </div>}
          </div>
        </div>
      </section>

      {work.length > 0 && <section className="border-t border-ink-line py-16" data-id="element-243" data-mp="2mp1wkq0j8u8e">
          <h2 className="px-6 text-center font-slab text-2xl font-bold uppercase tracking-[0.15em]" data-id="element-244" data-mp="2mqv385b5bege">Work by {artist.name}</h2>
          <div className="mx-auto mt-10 max-w-[1400px] px-1" data-id="element-245" data-mp="1vg74uspihnf8">
            <PortfolioGrid items={work} data-id="element-246" data-mp="1vedup3fowl2h" />
          </div>
        </section>}
    </>;
}